import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye } from '@/components/Icons/Eye';
import { EyeOff } from '@/components/Icons/EyeOff';
import { submitOnEnter } from '@/utils/form';

interface Props {
  label: string;
  value: string;
  placeholder: string;
  error?: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

export const PasswordField: React.FC<Props> = ({
  label,
  value,
  placeholder,
  error,
  onChange,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="flex flex-col">
      <label className="mb-2 text-body-14 text-foreground md:text-body-16">
        {label}
      </label>
      <div className="relative">
        <input
          type={isVisible ? 'text' : 'password'}
          autoComplete="off"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={submitOnEnter(onSubmit)}
          placeholder={placeholder}
          className="h-14 w-full rounded-xl border border-transparent bg-on-primary-surface pr-11 pl-4 text-body-16 text-foreground outline-none placeholder:text-subtle-foreground md:h-12"
        />
        <button
          type="button"
          onClick={() => setIsVisible((previous) => !previous)}
          aria-label={t(
            isVisible ? 'changePassword.hide' : 'changePassword.show',
          )}
          className="absolute top-1/2 right-3 flex size-6 -translate-y-1/2 cursor-pointer items-center justify-center text-muted-foreground"
        >
          {isVisible && <EyeOff className="size-4" />}
          {!isVisible && <Eye className="size-4" />}
        </button>
      </div>
      {error && <p className="mt-2 text-body-14 text-destructive">{error}</p>}
    </div>
  );
};
